/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Groups_SubInputs */

const en_no_groups_sub = /** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit a storefront's community tab to join`)
};

const es_no_groups_sub = /** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita la pestaña de la comunidad de una tienda para unirte`)
};

const fr_no_groups_sub = /** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitez l'onglet communauté d'une vitrine pour rejoindre`)
};

const de_no_groups_sub = /** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuche den Community-Tab einer Storefront, um beizutreten`)
};

const id_no_groups_sub = /** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunjungi tab komunitas etalase untuk bergabung`)
};

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const ja_no_groups_sub = en_no_groups_sub;

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const zh_no_groups_sub = en_no_groups_sub;

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const ar_no_groups_sub = en_no_groups_sub;

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const it_no_groups_sub = en_no_groups_sub;

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const ru_no_groups_sub = en_no_groups_sub;

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const pt_no_groups_sub = en_no_groups_sub;

/** @type {(inputs: No_Groups_SubInputs) => LocalizedString} */
const ko_no_groups_sub = en_no_groups_sub;

/**
* | output |
* | --- |
* | "Visit a storefront's community tab to join" |
*
* @param {No_Groups_SubInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_groups_sub = /** @type {((inputs?: No_Groups_SubInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Groups_SubInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_groups_sub(inputs)
	if (locale === "es") return es_no_groups_sub(inputs)
	if (locale === "fr") return fr_no_groups_sub(inputs)
	if (locale === "de") return de_no_groups_sub(inputs)
	if (locale === "ja") return ja_no_groups_sub(inputs)
	if (locale === "zh") return zh_no_groups_sub(inputs)
	if (locale === "ar") return ar_no_groups_sub(inputs)
	if (locale === "id") return id_no_groups_sub(inputs)
	if (locale === "it") return it_no_groups_sub(inputs)
	if (locale === "ru") return ru_no_groups_sub(inputs)
	if (locale === "pt") return pt_no_groups_sub(inputs)
	return ko_no_groups_sub(inputs)
});